module.exports = __webpack_public_path__ + "img/NewsCenterDetails4_pic2.7ab953a5.png";